import logging from '@wr/logging';
import {gatewayService} from '@wr/plutonium/services';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import eventIds from '../event-ids';
import {getTargetOrigin} from '../utils/getTargetOrigin';
import {getPaymentSessionId} from '../utils/helpers';
import config from '../config';

const getSavedCards = async ({
    languageCode, sessionId, requestId, params, query
}) => {
    const paymentSessionId = getPaymentSessionId(params, query);
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving saved cards details', {
        eventId: eventIds['Retrieving saved cards details'],
        ...logProps
    });

    try {
        const client = gatewayService({requestId, sessionID: sessionId}, languageCode);
        const savedCards = await client.cybersource.cardsRegistration(paymentSessionId, getTargetOrigin());

        logger.info('Retrieved saved card details', {
            eventId: eventIds['Retrieved saved card details'],
            ...logProps,
            payload: savedCards
        });

        return savedCards;
    } catch (e) {
        const error = new Error(`Error retrieving saved cards details: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving saved cards details'],
            ...logProps
        });

        throw error;
    }
};

export default getSavedCards;
